// extracted by mini-css-extract-plugin
export var endPage = "EndPage-module--endPage--E9M0S";
export var title = "EndPage-module--title--ntgyj";
export var text = "EndPage-module--text--D6Mul";
export var buttonStart = "EndPage-module--buttonStart--gG9y+";
export var imageJigsaw = "EndPage-module--imageJigsaw--A+U1J";